<script lang="ts" setup>
const { t } = useLang()
</script>

<template>
  <div class="quote-privacy-policy flex max-w-xlg m-auto text-xs text-text2 dark:text-dmText2">
    <div v-html="t('quotes.disclaimer', { link: '/privacy-policy' })"></div>
  </div>
</template>

<style lang="postcss">
.quote-privacy-policy {
  a {
    color: theme('colors.brand.primary');
    font-weight: bold;
    text-decoration: underline;
  }
}
</style>
